import { IAdapterData } from '../../../../../../redux/types';
import { IUserSlice } from './types';

export const initialAdapterState: IAdapterData = {
    data: null,
    loading: false,
    error: null
};
export const initialState: IUserSlice = {
    userData: {
        ...initialAdapterState
    },
    userAttributes: {
        ...initialAdapterState
    }
};
